import styled from "styled-components";

const LetterFormWrapper = styled.section<{ bgImage: string }>`
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: 266px;
  padding-bottom: 130px;

  @media (max-width: 767px) {
    padding-bottom: 0px;
  }

  .comment-form-button {
    color: var(--color-pink) !important;
  }
`;

const HeroButtonWrapper = styled.div`
  a {
    border: 2px solid var(--color-white);
  }
`;

const ForumRulesWrapper = styled.section`
  div,
  p {
    font-family: Avenir;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 160%;
  }
`;
export { ForumRulesWrapper, HeroButtonWrapper, LetterFormWrapper };
